import {
  BidsCollection,
  MessagesCollection,
  ProjectViewBidsCollection,
  ProjectViewProjectsCollection,
  ThreadsCollection,
} from '@freelancer/datastore/collections';
import { DatastoreFake, generateId } from '@freelancer/datastore/testing';
import { PartialBy } from '@freelancer/types';
import { toNumber } from '@freelancer/utils';
import { ProjectStatusApi } from 'api-typings/projects/projects';

export function addPushTransformers(datastore: DatastoreFake, authUid: number) {
  datastore.addPushTransformer<ProjectViewProjectsCollection>(
    'projectViewProjects',
    document => {
      const id = toNumber(document.id) ?? generateId();

      return {
        ...document,

        id,
        attachments: [],
        bidStats: { bidCount: 0 },
        location: {},
        deleted: false,
        hideBids: false,
        ownerId: 0,
        previewDescription: '',
        projectCollaborations: [],
        qualifications: [],
        seoUrl: `project-${id}`,
        status: ProjectStatusApi.ACTIVE,
        timeSubmitted: 0,
        selectedBids: [],
        canPostReview: {},
        isEscrowProject: false,
        isSellerKycRequired: false,
        isBuyerKycRequired: false,
        isDeloitteProject: true,
        isTokenProject: true,

        hireme: document.hireme ?? false,
        local: document.local ?? false,
        language: document.language ?? 'en',
        ndaDetails: document.ndaDetails ?? { signatures: [] },
      };
    },
  );

  datastore.addPushTransformer<BidsCollection>('bids', addGeneratedNumericalId);
  datastore.addPushTransformer<ProjectViewBidsCollection>(
    'projectViewBids',
    addGeneratedNumericalId,
  );
  datastore.addPushTransformer<ThreadsCollection>(
    'threads',
    addGeneratedNumericalId,
  );
  datastore.addPushTransformer<MessagesCollection>(
    'messages',
    addGeneratedNumericalId,
  );
}

function addGeneratedNumericalId<T extends { readonly id: number }>(
  document: PartialBy<T, 'id'>,
): T {
  return { ...document, id: toNumber(document.id) ?? generateId() } as any;
}
